import { cn } from "@babackapp/ui/lib/utils";
import { Column, Row } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import formatTemplate from "../../lib/format-template";
import { DEFAULT_FONT } from "../../utils/constants";
import type { ParagraphBlockProps } from "./types";

export default function ParagraphEmailRenderer({
  locale,
  block,
  formatter,
  theme,
  section,
  defaultLocale,
  isEditor = false,
}: ParagraphBlockProps & { isEditor?: boolean }) {
  const content =
    block.content?.[locale]?.html || block.content?.[defaultLocale]?.html || "";
  const alignment = block.alignment;
  const font = block.font ?? DEFAULT_FONT;
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  /**
   * Prevent empty line to be collapsed
   */
  let processedHtml = content.replace(/<p([^>]*)><\/p>/g, "<p$1>&nbsp;</p>");

  if (isEditor && processedHtml.trim() === "") {
    processedHtml = "<p>Cliquez pour ajouter du texte</p>";
  }

  return (
    <Row>
      <Column>
        <div
          // `color` comes from the theme-aware contextual text color (readable
          // foreground for the surface). Don't add a `text-*` class here — it
          // would either be a redundant duplicate of this inline color or, worse,
          // tint body copy with the brand primary color.
          style={{ color: colors.text, fontFamily: font }}
          className={cn(
            "font-sans text-sm leading-tight m-0 p-0",
            {
              left: "text-left",
              center: "text-center",
              right: "text-right",
            }[alignment],
          )}
          dangerouslySetInnerHTML={{
            __html: formatter(formatTemplate(processedHtml)),
          }}
        />
      </Column>
    </Row>
  );
}
